import { useEffect } from "react";
import { FieldValues, useFormContext } from "react-hook-form";

interface FormValueSyncProps<T extends FieldValues> {
    onChange?: (data: T) => void;
}

/**
 * Component that syncs form values to a parent component via onChange callback.
 * Place this inside a form (within GeneralFormProvider) to report current values.
 */
export const FormValueSync = <T extends FieldValues>({ onChange }: FormValueSyncProps<T>) => {
    const { watch, getValues } = useFormContext<T>();

    // Call onChange immediately on mount with current form values
    useEffect(() => {
        onChange?.(getValues());
    }, [onChange, getValues]);

    // Subscribe to form value changes using callback-based watch
    useEffect(() => {
        const subscription = watch((values) => {
            onChange?.(values as T);
        });
        return () => subscription.unsubscribe();
    }, [watch, onChange]);

    return null;
};
